import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=94929366&"
import script from "./VersionList.vue?vue&type=script&lang=ts&"
export * from "./VersionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports